module.exports = __webpack_public_path__ + "1a3baf027773e28cc3fabe768e3aedfa.png";